export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "/api",

  // Admin Authentication
  ADMIN_TOKEN_STORAGE_KEY: "adminAccessToken",
  ADMIN_REFRESH_TOKEN_KEY: "adminRefreshToken",
  ADMIN_USER_STORAGE_KEY: "adminUser",
  ADMIN_API_BASE_URL: process.env.REACT_APP_API_URL || "/api",

  REQUEST_TIMEOUT: 30000,
  UPLOAD_TIMEOUT: 120000,

  MAX_FILE_SIZE: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/webp", "image/gif"],
  MAX_IMAGES_PER_PRODUCT: 10,

  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,

  FEATURES: {
    SOCIAL_LOGIN: false,
    EMAIL_VERIFICATION: true,
    PASSWORD_RESET: true,
    FILE_UPLOAD: true,
    PUSH_NOTIFICATIONS: false,
  },

  ENDPOINTS: {
    ADMIN: {
      BASE: "",
      ANALYTICS: {
        DASHBOARD_STATS: "/analytics/dashboard-stats",
        USER_GROWTH: "/analytics/user-growth",
        PRODUCTS: "/analytics/products",
        REQUESTS: "/analytics/requests",
        ACTIVITY_LOGS: "/analytics/activity-logs",
      },
      USERS: {
        LIST: "/users",
        GET: "/users/:id",
        UPDATE_STATUS: "/users/:id/status",
        UPDATE_VERIFICATION: "/users/:id/verification",
        ACTIVITY: "/users/:id/activity",
        DELETE: "/users/:id",
        STATS: "/users/stats",
      },
      PRODUCTS: {
        LIST: "/products",
        GET: "/products/:id",
        UPDATE_STATUS: "/products/:id/status",
        DELETE: "/products/:id",
        FLAGGED: "/products/flagged",
        STATS: "/products/stats",
      },
      REQUESTS: {
        LIST: "/requests",
        GET: "/requests/:id",
        UPDATE_STATUS: "/requests/:id/status",
        DELETE: "/requests/:id",
        FLAGGED: "/requests/flagged",
        STATS: "/requests/stats",
      },
    },
  },
};

export const isDevelopment = process.env.NODE_ENV === "development";
export const isProduction = process.env.NODE_ENV === "production";
